import { getCountryData } from '../../helpers/country-dropdown';

import CountryFlag from "../../shared/country-flag";
import SelectDropdown from '../select-dropdown/select-dropdown';
import countryDD from "../../assets/stylesheets/core/dropdown/countryDropdown.module.scss";

interface CountryProps {
  name: string;
  iso: string;
  id: number;
}

interface CountrySelectProps {
  selectedCountry: CountryProps;
  countries: CountryProps[];
  setSelectedCountry: () => void;
  type: string;
  labelText: string
}

const CountrySelect = (props: CountrySelectProps) => {
  const { countries, selectedCountry, setSelectedCountry, type, labelText="Country" } = props;

  const getCountryText = (countryObj = {}) => {
    const { iso, name } = countryObj;
    if (iso)
      return (
        <div className="d-flex align-items-center px-4">
          <CountryFlag key={iso} country={countryObj} type={type} className="img-flag h-100" />
          <div className={`text-truncate fs-10 lh-1-2 ls-1 ml-2 ${countryDD.countryLabel}`}>{name}</div>
        </div>
      );
    return "";
  };

  const getCountryDataHandler = () => {
    const countryDataOptions = { countryOptionParams: { getText: getCountryText } };
    return getCountryData(countries, countryDataOptions);
  };

  const { countryMapping, countryOptions } = getCountryDataHandler()

  const handleCountryChange = ({ value: countryId }) => {
    if (countryId && selectedCountry.iso != countryId) {
      setSelectedCountry(countryMapping[countryId])
    }
  };

  return <SelectDropdown
    name="countryId"
    id="countryId"
    value={selectedCountry?.iso}
    options={countryOptions}
    text={getCountryText(countryMapping[selectedCountry?.iso])}
    onSelect={handleCountryChange}
    label={{
      for: "countryId",
      content: labelText,
      classes: "fs-12 lh-1-3 ls-1 text-uppercase font-weight-bold clr-052",
    }}
    placeholder="United States"
    classes="country-dropdown w-100"
    showSearchFilter
    searchfilterOptions={{
      placeholder: "Search",
      attributes: ["iso", "name"],
    }}
  />

}

export default CountrySelect;
